import React, { FC, memo, useEffect } from "react";
import classes from "./DisplayArea.module.scss";
import { WorkerForMatrix } from "../../../types/dirary";
import Results from "../organizms/Results";

type Props = {
  productNo: string;
  setProductNo: React.Dispatch<React.SetStateAction<string>>;
  productBno: string;
  setProductBno: React.Dispatch<React.SetStateAction<string>>;
};

const DisplayArea: FC<Props> = memo((props) => {
  const { productNo, setProductNo, productBno, setProductBno } = props;
  return (
    <div className={classes.rootContainer}>
      <Results
        productNo={productNo}
        setProductNo={setProductNo}
        productBno={productBno}
        setProductBno={setProductBno}
      />
    </div>
  );
});
export default DisplayArea;
